import type { NightMode, NightStep, Phase, Role, Side, WinReason, Winner } from '../shared/index.js';

export const s = {
  name: 'Kurt Adam',
  pitch: 'Köy uyurken kurtlar avlanır; gündüz kimin kurt olduğunu bulup asın',

  role: {
    wolf: 'Kurt Adam',
    villager: 'Köylü',
    seer: 'Kahin',
    doctor: 'Doktor',
    hunter: 'Avcı',
    witch: 'Cadı',
    cupid: 'Aşk okçusu',
    fool: 'Köyün delisi',
  } satisfies Record<Role, string>,
  rolePlural: {
    wolf: 'Kurt',
    villager: 'Köylü',
    seer: 'Kahin',
    doctor: 'Doktor',
    hunter: 'Avcı',
    witch: 'Cadı',
    cupid: 'Okçu',
    fool: 'Deli',
  } satisfies Record<Role, string>,
  roleBlurb: {
    wolf: 'Her gece diğer kurtlarla birlikte bir kurban seçersin. Gündüz köylü gibi davran; sayınız köylülere eşit olunca kazanırsınız.',
    villager: 'Gece uyursun. Gündüz konuş, şüphelendiğini aday göster ve kurtları asmaya çalış.',
    seer: 'Her gece bir kişinin kurt olup olmadığını öğrenirsin. Bildiğini dikkatli paylaş; kurtlar seni arar.',
    doctor: 'Her gece bir kişiyi kurtlara karşı korursun. Kendini de koruyabilirsin.',
    hunter: 'Öldüğün an birini yanında götürürsün. Köyün tarafındasın.',
    witch: 'Bir iyileştirme ve bir zehir iksirin var. Her gece kurtların kurbanını görürsün; iksirleri oyun boyunca birer kez kullanırsın.',
    cupid: 'İlk gece iki kişiyi âşık edersin. Biri ölürse diğeri de ölür. Sen köyün tarafındasın.',
    fool: 'Tek amacın gündüz oylamasında asılmak. Asılırsan tek başına kazanırsın; gece ölürsen kaybedersin.',
  } satisfies Record<Role, string>,
  side: { wolves: 'kurt tarafı', village: 'köy tarafı' } satisfies Record<Side, string>,

  step: {
    cupid: 'Aşk okçusu',
    wolves: 'Kurtlar',
    seer: 'Kahin',
    doctor: 'Doktor',
    witch: 'Cadı',
  } satisfies Record<NightStep, string>,
  allWake: 'Herkes aynı anda uyanıyor. Ekranındaki işi yap, kimseye gösterme.',
  stepWakes: {
    cupid: 'Aşk okçusu uyanıyor ve iki kişiyi âşık ediyor.',
    wolves: 'Kurtlar uyanıyor ve kurbanını seçiyor.',
    seer: 'Kahin uyanıyor ve birine bakıyor.',
    doctor: 'Doktor uyanıyor ve birini koruyor.',
    witch: 'Cadı uyanıyor ve iksirlerine bakıyor.',
  } satisfies Record<NightStep, string>,

  phase: {
    night: 'Gece',
    hunter: 'Avcının son atışı',
    discuss: 'Tartışma',
    vote: 'Oylama',
    verdict: 'Karar',
    over: 'Oyun bitti',
  } satisfies Record<Phase, string>,

  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    roles: 'Roller',
    rolesHint: 'Kurt sayısını ve açılacak rolleri seç; kalan herkes köylü olur.',
    villagers: (n: number) => (n >= 0 ? `${n} köylü` : 'Köylüye yer kalmadı'),
    recommend: (n: number) => `${n} kişi için önerilen dağılım`,
    recommendShort: 'Önerilen dağılım',
    less: (r: string) => `${r} sayısını azalt`,
    more: (r: string) => `${r} sayısını artır`,
    roleSeconds: 'Gece rol süresi',
    roleSecondsHint: 'Her rol gece bu kadar süre uyanık kalır. Erken bitiş kapalıysa rol erken bitirse de süre dolmadan sıra geçmez; böylece kimse kimin hangi rolde olduğunu süreden anlayamaz.',
    nightMode: 'Gece düzeni',
    nightModeOpts: { sequential: 'Sıralı', simultaneous: 'Aynı anda' } satisfies Record<NightMode, string>,
    nightModeHint: {
      sequential: 'Roller tek tek uyanır. Kim hangi sırada telefonuna bakıyor, dikkatli olan rolleri tahmin edebilir.',
      simultaneous:
        'Bütün roller birlikte uyanır; cadı kurbanı görmek için kısa bir ikinci turda oynar. Rolü olmayanlar ve işini bitirenler o sırada ateşböceği toplar, böylece herkes aynı anda telefonuyla uğraşır.',
    } satisfies Record<NightMode, string>,
    nightEnd: 'Gece bitişi',
    nightEndsEarly: 'Herkes bitirince gece erken bitsin',
    nightEndsEarlyHint: {
      sequential: 'Sıralı düzende erken bitiş, rolün sahibinin ölü olup olmadığını süreden ele verebilir.',
      simultaneous: 'Rolü olanlar seçimini, diğerleri ateşböceklerini bitirince tur süreyi beklemeden kapanır.',
    } satisfies Record<NightMode, string>,
    discussSeconds: 'Tartışma süresi',
    discussHint: 'Hayattaki herkes "Hazırım" derse tartışma erken biter.',
    voteSeconds: 'Oylama süresi',
    rules: 'Kurallar',
    revealRoles: 'Ölenin rolü açıklansın',
    openVotes: 'Açık oy (kim kime oy verdi görünsün)',
    doctorNoRepeat: 'Doktor aynı kişiyi üst üste koruyamaz',
    ghostsSeeRoles: 'Ölüler bütün rolleri görsün',
    dayTie: 'Gündüz oylamasında beraberlik',
    dayTieOpts: { none: 'Kimse asılmaz', runoff: 'İkinci tur' },
    wolfTie: 'Kurt oylamasında beraberlik',
    wolfTieOpts: { random: 'Rastgele biri', none: 'Kimse ölmez' },
    sec: (n: number) => (n < 60 ? `${n} sn` : n % 60 === 0 ? `${n / 60} dk` : `${n} sn`),
  },

  play: {
    you: 'sen',
    night: (n: number) => `${n}. gece`,
    day: (n: number) => `${n}. gün`,
    village: 'Köy',
    inGame: 'Oyundaki roller',
    alive: (n: number) => `${n} kişi hayatta`,
    dead: 'Öldü',
    ready: 'Hazır',
    voted: 'Oy verdi',
    nominated: (n: number) => `${n} aday gösterme`,

    // Rol kartı
    roleHold: 'Rolünü görmek için basılı tut',
    roleHoldHint: 'Yanındakiler görmesin diye yalnızca basılıyken açılır.',
    allies: 'Diğer kurtlar',
    noAllies: 'Bu oyunda tek kurt sensin.',
    lover: (nick: string, side: string) => `${nick} ile âşıksın (${side}). Biriniz ölürse diğeri de ölür.`,
    loverMixed: 'Farklı taraftasınız: ikiniz son iki kişi kalırsanız birlikte kazanırsınız.',
    cupidPair: (a: string, b: string) => `Âşık ettiklerin: ${a} ve ${b}`,
    seerResults: 'Bakışların',
    isWolf: 'kurt',
    notWolf: 'kurt değil',
    potions: (heal: boolean, poison: boolean) =>
      `İksirler: iyileştirme ${heal ? 'duruyor' : 'kullanıldı'}, zehir ${poison ? 'duruyor' : 'kullanıldı'}.`,
    youDied: 'Öldün. Artık konuşamazsın; hayaletler kanalından izleyebilirsin.',

    // Gece
    sleepTitle: 'Gözlerini kapat, köy uyuyor',
    sleepBody: 'Sıran gelirse ekranın kendiliğinden uyanır. Ekranını kimseye gösterme.',
    nightOrder: 'Gecenin sırası',
    aliveNow: 'Köyde hayatta olanlar',
    cupidTitle: 'İki kişiyi âşık et',
    cupidHint: 'Kendini de seçebilirsin. Biri ölürse diğeri de ölür; farklı taraftalarsa birlikte kazanabilirler.',
    cupidConfirm: (a: string, b: string) => `${a} ve ${b} kişisini âşık et`,
    cupidPick: 'İki kişi seç',
    cupidDone: (a: string, b: string) => `${a} ile ${b} artık âşık. Süre dolunca uyuyacaksın.`,
    wolvesTitle: 'Bu gece kimi avlıyorsunuz?',
    wolvesHint: 'En çok oyu alan ölür. Oyunu süre dolana kadar değiştirebilirsin; diğer kurtların seçimini görüyorsun.',
    wolvesWithdraw: 'Oyumu geri al',
    wolfVotes: (n: number) => `${n} kurt`,
    seerTitle: 'Kime bakmak istiyorsun?',
    seerHint: 'Gecede bir kişiye bakabilirsin. Sonucu yalnızca sen görürsün.',
    seerIsWolf: (nick: string) => `${nick} bir kurt.`,
    seerNotWolf: (nick: string) => `${nick} kurt değil.`,
    doctorTitle: 'Bu gece kimi koruyorsun?',
    doctorHint: 'Koruduğun kişi kurtların saldırısından kurtulur; cadının zehrinden değil.',
    doctorBlocked: 'Dün gece korudun',
    doctorDone: (nick: string) => `Bu gece ${nick} kişisini koruyorsun.`,
    witchTitle: 'İksirlerin',
    witchVictim: (nick: string) => `Kurtlar bu gece ${nick} kişisini seçti.`,
    witchNoVictim: 'Kurtlar bu gece kimseyi seçmedi.',
    witchHeal: (nick: string) => `${nick} kişisini iyileştir`,
    witchHealUsed: 'İyileştirme iksirini kullandın.',
    witchPoison: 'Zehirlemek istediğin kişi',
    witchPoisonUsed: 'Zehir iksirini kullandın.',
    witchNoPoison: 'Kimseyi zehirleme',
    witchConfirm: 'Kararımı ver',
    witchHint: 'Kararını bir kez verirsin. Süre dolarsa iksir kullanmadan geçersin.',
    witchDone: 'Kararını verdin. Süre dolunca uyuyacaksın.',
    stepDone: 'Seçimin kaydedildi. Süre dolunca uyuyacaksın.',
    // Aynı anda düzeni: mini oyun
    choresTitle: 'Ateşböceklerini topla',
    choresHint: (left: number) => `Yanan ateşböceğine dokun. ${left} tane kaldı.`,
    choresWait: 'Herkes işini yaparken sen de ateşböceklerini topla.',
    choresDone: 'Hepsini topladın. Gece bitene kadar toplamaya devam edebilirsin.',
    choresCaught: (n: number) => `${n} ateşböceği`,
    firefly: 'Ateşböceği',
    fireflyOff: 'Boş çalı',
    stepLeft: (sec: number) => `${sec} sn`,
    deadNight: 'Ölüler gece uyanmaz. Hayaletler kanalında olanları izleyebilirsin.',

    // Kurt sohbeti
    wolfChat: 'Kurtların sohbeti',
    wolfChatHint: 'yalnızca kurtlar görür',
    chatEmpty: 'Henüz mesaj yok.',
    chatPlaceholder: 'Mesaj yaz',
    send: 'Gönder',

    // Sabah
    dawnTitle: (n: number) => `${n}. gecenin sabahı`,
    dawnNone: 'Bu gece kimse ölmedi.',
    dawnDied: 'Bu gece ölenler',

    // Avcı
    hunterTitle: 'Son atışın: yanında kimi götürüyorsun?',
    hunterHint: 'Süre dolarsa atış yapmadan ölürsün.',
    hunterWait: (nick: string) => `${nick} avcıymış. Son atışını yapıyor.`,

    // Tartışma
    discussRule: 'Hayattakiler konuşur, ölüler susar. Rol kartını kimseye gösterme.',
    discussPick: 'Aday göstermek için birine dokun',
    candidates: 'Adaylar',
    noCandidates: 'Henüz aday yok. Kimse aday gösterilmezse bugün kimse asılmaz.',
    nominatedBy: (names: string) => `Aday gösteren: ${names}`,
    nominate: (nick: string) => `${nick} kişisini aday göster`,
    withdraw: 'Adaylığı geri çek',
    myNomination: (nick: string) => `${nick} kişisini aday gösterdin.`,
    readyBtn: 'Hazırım, oylamaya geçelim',
    unready: 'Hazır değilim',
    readyCount: (a: number, b: number) => `${a}/${b} kişi hazır`,
    endDiscuss: 'Tartışmayı bitir',
    deadDiscuss: 'Ölüler tartışmaya katılmaz. Hayaletler kanalını kullanabilirsin.',
    spectator: 'Bu oyunu izliyorsun.',

    // Oylama
    voteTitle: 'Kimi asıyoruz?',
    runoffTitle: 'İkinci tur: yalnızca berabere kalanlar',
    voteHint: (open: boolean) => (open ? 'Açık oy: herkes kimin kime oy verdiğini görür.' : 'Gizli oy: yalnızca sayılar açıklanır.'),
    voteNone: 'Kimseyi asma',
    voteProgress: (a: number, b: number) => `${a}/${b} kişi oy verdi`,
    voteMine: (nick: string) => `Oyun: ${nick}`,
    endVote: 'Oylamayı bitir',
    deadVote: 'Ölüler oy veremez.',

    // Karar
    hanged: (nick: string) => `${nick} asıldı.`,
    hangedRole: (role: string) => `Rolü: ${role}`,
    spared: 'Bugün kimse asılmadı.',
    sparedTie: 'Oylar eşit çıktı; kimse asılmadı.',
    sparedNone: 'Kimse aday gösterilmedi.',
    tally: 'Oylar',
    nobody: 'Kimse',
    nightFalls: 'Birazdan gece çöküyor.',

    // Hayaletler
    ghosts: 'Hayaletler',
    ghostHint: 'yalnızca ölüler görür, hayattakilere ipucu verme',
    ghostRoles: 'Herkesin rolü',
    ghostSecret: 'Gece olanlar',

    // Sonuç
    winner: {
      village: 'Köy kazandı',
      wolves: 'Kurtlar kazandı',
      fool: 'Köyün delisi kazandı',
      lovers: 'Âşıklar kazandı',
    } satisfies Record<Winner, string>,
    noWinner: 'Oyun yarıda bitti',
    reason: {
      wolvesDead: 'Bütün kurtlar öldü.',
      wolvesParity: 'Kurtlar sayıca köylülere yetişti.',
      foolHanged: 'Deli asılmayı başardı.',
      loversLast: 'Farklı taraftaki âşıklar son iki kişi kaldı.',
      ended: 'Oda sahibi oyunu bitirdi.',
    } satisfies Record<WinReason, string>,
    rolesTitle: 'Roller',
    secretTitle: 'Gece neler oldu',
    backIn: (n: number) => `Lobiye dönülüyor… · ${n} sn`,
    gameOver: 'Oyun bitti',
    winnerTitle: {
      village: 'Köy kazandı!',
      wolves: 'Kurtlar kazandı!',
      fool: 'Köyün delisi kazandı!',
      lovers: 'Âşıklar kazandı!',
    } satisfies Record<Winner, string>,
    sideWolves: 'Kurtlar',
    sideVillage: 'Köy',
    backNow: 'Lobiye dön',
    log: 'Olay günlüğü',
    logEmpty: 'Henüz bir şey olmadı.',
    pending: 'Gönderiliyor…',
  },

  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Rolünü gizlice öğren', 'Rol kartına basılı tutunca rolün görünür. Kurtlar birbirini tanır; diğer herkes yalnızca kendini bilir.'],
      ['Gece', 'Anlatıcı sunucudur. Sıralı düzende roller tek tek uyanır: aşk okçusu (ilk gece), kurtlar, kahin, doktor, cadı; ekranın uyanmazsa uyumaya devam et. Aynı anda düzeninde herkes birlikte uyanır, rolü olmayanlar ateşböceği toplar.'],
      ['Sabah', 'Gece ölenler açıklanır. Avcı öldüyse son atışını yapar.'],
      ['Tartışma', 'Hayattakiler konuşur, şüphelendiklerini aday gösterir. Herkes hazır olunca ya da süre dolunca oylamaya geçilir.'],
      ['Oylama', 'Herkes aynı anda adaylardan birine ya da "Kimseyi asma"ya oy verir. En çok oyu alan asılır.'],
      ['Kazanma', 'Bütün kurtlar ölünce köy, kurtlar köylülere yetişince kurtlar kazanır. Deli asılırsa deli, farklı taraftaki âşıklar son iki kişi kalırsa âşıklar kazanır.'],
    ] as [string, string][],
    roleTable: 'Roller',
  },
};
